"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProof = getProof;

var _fetch = _interopRequireDefault(require("@/utils/fetch"));

function getProof(params) {
  return _fetch.default.get("/Antchain/logistics/proof", params);
}